import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputWithActionField from 'dashboard/components/FormControls/InputWithActionField';
import { FORM_ADD_ALLOWED_URI_SCHEME } from 'dashboard/lib/constants/formNames';
import { URI_SCHEME_REGEX } from 'lib/constants/regexes';
import FormControlField from 'lib/interfaces/FormControlField';
import { isRequired, matchesRegexp, withMessage } from 'lib/utils/formValidation';

const FormRow = styled('div')`
  position: relative;
`;

const validate = {
  uriScheme: [
    withMessage('Please enter a URI scheme', isRequired),
    withMessage('Please enter a valid URI scheme', matchesRegexp(URI_SCHEME_REGEX)),
  ],
};

interface FormAddAllowedUriSchemeProps {
  disabled?: boolean;
}

const FormAddAllowedUriScheme = ({
  handleSubmit,
  submitting,
  disabled,
  submit,
}: InjectedFormProps & DecoratedFormProps & FormAddAllowedUriSchemeProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <FormControlField
          component={InputWithActionField}
          name='uriScheme'
          id='uriScheme'
          type='text'
          data-test='form-add-allowed-uri-scheme__uri-scheme'
          disabled={submitting || disabled}
          validate={validate.uriScheme}
          placeholder='http'
          actionLabel='Add'
          onSubmit={submit}
        />
      </FormRow>
    </form>
  );
};

export interface AddAllowedUriSchemeFormData {
  uriScheme: string;
}

export default reduxForm<AddAllowedUriSchemeFormData, FormAddAllowedUriSchemeProps>({
  form: FORM_ADD_ALLOWED_URI_SCHEME,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormAddAllowedUriScheme);
